import { createEvent, createStore } from 'effector';

export const $duration = createStore<number>(2000);
export const setDuration = createEvent<number>();
export const $show = createStore<boolean>(false);
export const setShow = createEvent<boolean>();

$show.on(setShow, (_, payload) => {
  return payload;
});

$duration.on(setDuration, (_, payload) => {
  return payload;
});
